import {select} from '@ngneat/elf';

import {documentsStore} from '@store/documents/documents.store';
import {getDocumentsDataSource} from '@store/documents/documents.requests';

export class DocumentsQuery {
  store = documentsStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  documents$ = getDocumentsDataSource.data$();

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const documentsQuery = new DocumentsQuery();
